module.exports = __webpack_public_path__ + "img/icon14.5418e993.png";